import * as simpleslider from 'simple-slider';

const CAROUSEL_DELAY_SECONDS = 10;

let isSliderReversed = false;

Array.prototype.forEach.call(
  document.querySelectorAll('.sb-accordion-title.sbf-accordion-group__title'),
  function (item) {
    try {
      item.addEventListener('click', function () {
        item.classList.toggle('sb-accordion-title--open');
        const next = item.nextElementSibling.classList;
        const opened = 'sb-collapsible-content--opened';
        const closed = 'sb-collapsible-content--closed';
        const slider = item.nextElementSibling.querySelector('.sb-collapsible-content__slider');
        if (next.contains(closed)) {
          next.remove(closed);
          next.add(opened);
          slider.style.height = slider.childElementCount * 42 + 'px';
        } else {
          next.add(closed);
          next.remove(opened);
          slider.style.height = '0px';
        }
      });
    } catch (e) {}
  }
);

const switchActiveSliderDot = () => {
  if (isSliderReversed) {
    slider.reverse();
    isSliderReversed = false;
  }
  document.querySelector('.slider-dots .active').classList.remove('active');
  document.querySelector(`.slider-dots :nth-child(${slider.currentIndex() + 1})`).classList.add('active');
};

const switchActiveImage = (dotIndex, numberOfSlides) => {
  const currentImageIndex = slider.currentIndex();
  if (currentImageIndex < dotIndex) {
    slider.change(dotIndex);
  } else if (currentImageIndex > dotIndex) {
    slider.reverse();
    isSliderReversed = true;
    slider.change(Math.abs(dotIndex - numberOfSlides + 1));
  }
};

const slider = simpleslider.getSlider({
  delay: CAROUSEL_DELAY_SECONDS,
  onChange: switchActiveSliderDot,
});

const slides = document.querySelectorAll('.slider-slide');
const dots = document.querySelector('.slider-dots');

slides.forEach(function (_, i, array) {
  const a = document.createElement('li');
  if (slider.currentIndex() === i) a.classList.add('active');
  a.addEventListener('click', () => switchActiveImage(i, array.length));
  dots.appendChild(a);
});

document.querySelector('.slider-arrow.right').addEventListener('click', function (e) {
  slider.next();
  e.preventDefault();
});

document.querySelector('.slider-arrow.left').addEventListener('click', function (e) {
  slider.reverse();
  isSliderReversed = true;
  slider.next();
  e.preventDefault();
});
